export default "__VITE_ASSET__BFr9wsLg__"